import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  configLoadSuccess,
  configLoadFailure,
  addNotification
} from '../actions'
import { uiConstants } from '../../constants'
import { uiHelper } from '../../helpers'

export function* configLoadSaga(action) {
  try {
    let result = null
    result = yield axios.get(
      `${uris.configBaseUrl}${action.payload}${uris.configFile}`
    )

    yield put(configLoadSuccess(result.data))
  } catch (error) {
    yield put(configLoadFailure(error))
    yield put(
      addNotification(
        uiHelper.errorMessage(error),
        uiConstants.notification.error
      )
    )
  }
}
